const now = () => Date.now();

const cachePrefix = 'cache:';
const hour = 60 * 60 * 1000; // 1 hour in ms

export const setCache = (key, value, ttl = hour) => {
    try {
        localStorage.setItem(cachePrefix+key, JSON.stringify({value, expire: now() + ttl}))
    } catch (_) {}
};

export const getCache = (key) => {
    try {
        const raw = localStorage.getItem(cachePrefix+key);
        const data = raw ? JSON.parse(raw) : null;

        if (data?.expire > now()) return data.value;

        localStorage.removeItem(cachePrefix + key);
        return null;
    } catch (e) {
        localStorage.removeItem(cachePrefix+key);
        return null;
    }
};

export const cleanExpiredCache = () => {
    for (let i = localStorage.length - 1; i >= 0; i--) {
        const fullKey = localStorage.key(i);

        if (!fullKey?.startsWith(cachePrefix)) continue;

        try {
            const raw = localStorage.getItem(fullKey);
            const data = raw ? JSON.parse(raw) : null;

            if (data?.expire && data?.expire < now()) {
                localStorage.removeItem(fullKey);
            }
        } catch (e) {
            localStorage.removeItem(fullKey);
        }
    }
};
